import { useEffect, useContext, useState } from "react";
import MapContext from "../map/MapContext";
import olMap from "ol/Map";
import olVectorSource from "ol/source/Vector";
import olVectorLayer from "ol/layer/Vector";
import olGeometry from "ol/geom/Geometry";
import { StyleLike as olStyleLike } from "ol/style/Style";

export interface VectorProps {
  name: string;
  source: olVectorSource;
  visible?: boolean;
  style?: olStyleLike;
  declutter?: boolean;
  zIndex?: number;
}

export const Vector = ({
  name,
  source,
  visible = true,
  style,
  declutter = false,
  zIndex = 0,
}: VectorProps) => {
  const map = useContext(MapContext) as olMap;
  const [layer, setLayer] = useState<olVectorLayer<
    olVectorSource<olGeometry>
  > | null>(null);

  useEffect(() => {
    if (!map) return () => {};

    const layer = new olVectorLayer({
      source,
      visible,
      style,
      declutter,
      zIndex,
    });

    layer.set("Name", name);

    map.addLayer(layer);
    setLayer(layer);

    return () => {
      if (!map) return;
      map.removeLayer(layer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  useEffect(() => {
    if (!layer) return;
    layer.set("name", source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  useEffect(() => {
    if (!layer) return;
    layer.setSource(source);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  useEffect(() => {
    if (!layer) return;
    layer.setVisible(visible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    if (!layer) return;
    layer.setStyle(style);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [style]);

  return null;
};
